export default __webpack_public_path__ + "media/images/temporary/mud-run-long-cf8050a165bb01437b76eae3926699f0.jpg";